import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { ServicesGrid } from "@/components/site/ServicesGrid";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export const Route = createFileRoute("/services")({
  component: ServicesPage,
  head: () => ({
    meta: [
      { title: "Services — Custom Tile, Stone & Flooring | RKD Tile" },
      {
        name: "description",
        content:
          "Custom tile and stone services across Utah: flooring, bathrooms, kitchens, fireplaces, natural stone, mosaics, and commercial tile.",
      },
      { property: "og:title", content: "Services — RKD Tile" },
      { property: "og:url", content: "https://rkdtile.com/services" },
      {
        property: "og:description",
        content:
          "Custom tile and stone services across Utah: flooring, bathrooms, kitchens, fireplaces, natural stone, mosaics, and commercial tile.",
      },
    ],
    links: [{ rel: "canonical", href: "https://rkdtile.com/services" }],
  }),
});

function ServicesPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <section className="py-20 md:py-28 bg-cream border-b border-border">
          <div className="container-prose text-center max-w-3xl mx-auto">
            <span className="eyebrow">What we do</span>
            <h1 className="mt-3 font-display text-4xl md:text-6xl text-foreground leading-tight">
              Custom Tile & Stone Services
            </h1>
            <p className="mt-5 text-muted-foreground text-lg leading-relaxed">
              30 years of custom tile and stone work for Utah homeowners and builders —
              from a single backsplash to a full custom build.
            </p>
          </div>
        </section>
        <ServicesGrid />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}